import React, { FC } from 'react';
import styled from 'styled-components';
import { switchProp } from 'styled-tools';
import {
  CusOrdBackground,
  CusOrdColor,
  DelvryBackground,
  DelvryColor,
  OrdResBackground,
  OrdResColor,
  POitemBackground,
  POitemColor,
  PrdOrdBackground,
  PrdOrdColor,
  ShpgNtBackground,
  ShpgNtColor,
  StockBackground,
  StockColor,
} from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';

export const StyledBadge = styled.div`
  display: inline-block;
  vertical-align: middle;
  line-height: 1.5rem;
  border-radius: 0.25rem;
  padding: 0rem 0.75rem;
  font-size: 0.75rem;
  font-family: ${DemiBold};
`;

export interface IMrpCodeBadgeProps {
  variant: string;
}

const StyledMrpCodeBadge = styled(StyledBadge)<IMrpCodeBadgeProps>`
  background-color: ${switchProp('variant', {
    Stock: StockBackground,
    Delvry: DelvryBackground,
    ShpgNt: ShpgNtBackground,
    PrdOrd: PrdOrdBackground,
    CusOrd: CusOrdBackground,
    POitem: POitemBackground,
    OrdRes: OrdResBackground,
  })};

  color: ${switchProp('variant', {
    Stock: StockColor,
    Delvry: DelvryColor,
    ShpgNt: ShpgNtColor,
    PrdOrd: PrdOrdColor,
    CusOrd: CusOrdColor,
    POitem: POitemColor,
    OrdRes: OrdResColor,
  })};
`;

const MrpCodeBadge: FC<IMrpCodeBadgeProps> = ({
  children,
  variant = 'default',
}) => {
  return <StyledMrpCodeBadge variant={variant}>{children}</StyledMrpCodeBadge>;
};

export { MrpCodeBadge };
